import { createContext, useContext, useState, ReactNode } from "react";
import { TABS } from "../constants";

interface LayoutContextType {
  activeTab: string;
  toggleTab: (tabId: string) => void;
}

const LayoutContext = createContext<LayoutContextType | null>(null);

export const LayoutProvider = ({ children }: { children: ReactNode }) => {
  const [activeTab, setActiveTab] = useState<string>(TABS.ROBOT); // Tab inicial

  const toggleTab = (tabId: string) => {
    // console.log("[LayoutCOntex][log1] toggleTab called with:", tabId); // <-- LOG 1
    // console.log("[LayoutCOntex][log2] activeTab changed:", activeTab); // <-- LOG 2
    setActiveTab(tabId);
  };

  return (
    <LayoutContext.Provider value={{ activeTab, toggleTab }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error("useLayout deve ser usado dentro de LayoutProvider");
  }
  return context;
};

